import { API_BASE_URL, apiRequest, tokenManager } from './api';

const API_PREFIX = '/camasirhane';

function buildUrl(path, params) {
  let endpoint = `${API_PREFIX}${path}`;
  if (params && Object.keys(params).length) {
    const qs = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
    ).toString();
    if (qs) endpoint += `?${qs}`;
  }
  return endpoint;
}

function unwrapApiData(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  if (data && Array.isArray(data.data)) return data.data;
  return data;
}

async function request(method, path, body, config = {}) {
  const endpoint = buildUrl(path, config.params);
  const options = { method, ...config };

  if (body !== undefined) {
    // FormData ve hazır string gövdeler olduğu gibi; nesneler JSON'a çevrilir.
    options.body =
      body instanceof FormData || typeof body === "string"
        ? body
        : JSON.stringify(body);
  }

  if (config.headers) {
    options.headers = config.headers;
  }

  try {
    const data = unwrapApiData(await apiRequest(endpoint, options));
    return { data };
  } catch (error) {
    error.response = { data: { detail: error.message } };
    throw error;
  }
}

const client = {
  get: (path, config = {}) => request('GET', path, undefined, config),
  post: (path, body, config = {}) => request('POST', path, body, config),
  put: (path, body, config = {}) => request('PUT', path, body, config),
  patch: (path, body, config = {}) => request('PATCH', path, body, config),
  delete: (path, config = {}) => request('DELETE', path, undefined, config),
};

export function getAuthToken() {
  return tokenManager.getAccessToken();
}

export async function downloadCamasirhaneFile(path, params, filename) {
  const token = getAuthToken();
  const qs = new URLSearchParams(params).toString();
  const url = `${API_BASE_URL}${API_PREFIX}${path}${qs ? `?${qs}` : ''}`;

  const response = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  if (!response.ok) {
    throw new Error('Dışa aktarma başarısız.');
  }

  const blob = await response.blob();
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}

export const camasirhaneApi = {
  getMe: () => apiRequest(`${API_PREFIX}/me/`),

  getModuleAccessUsers: () => apiRequest(`${API_PREFIX}/module-access/`),

  updateModuleAccessUsers: (userIds) =>
    apiRequest(`${API_PREFIX}/module-access/`, {
      method: 'PUT',
      body: JSON.stringify({ user_ids: userIds }),
    }),
};

export default client;
